import {ApiClient} from '@hconnect/apiclient'
import {useMutation, UseMutationOptions, useQueryClient} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {ChangeFunctionApproverGroupApprovalRequirement} from '../types'

import {QueryKey as ApproversByFunctionIdQueryKey} from './useApproversByFunctionId'
import {ChangeFunctionApproverGroupApprovalRequirementsQueryKey} from './useChangeFunctionApproverGroupApprovalRequirements'

export const useEditChangeFunctionApproverGroupApprovalRequirements = (
  {plantId}: {plantId: string},
  options?: UseMutationOptions<never, AxiosError, ChangeFunctionApproverGroupApprovalRequirement[]>
) => {
  const queryClient = useQueryClient()

  return useMutation<never, AxiosError, ChangeFunctionApproverGroupApprovalRequirement[]>({
    mutationFn: async (changeFunctionApproverGroupApprovalRequirements) => {
      const path = `/shifthandover/${plantId}/system-change-requests/change-function-approver-group-approval-requirements`
      const {data} = await ApiClient.axiosInstance.put<never>(
        path,
        changeFunctionApproverGroupApprovalRequirements
      )
      return data
    },
    ...options,
    onSuccess: async (data, variables, context, mutation) => {
      await queryClient.invalidateQueries({
        queryKey: [ChangeFunctionApproverGroupApprovalRequirementsQueryKey]
      })
      await queryClient.invalidateQueries({queryKey: [ApproversByFunctionIdQueryKey]})
      options?.onSuccess?.(data, variables, context, mutation)
    }
  })
}
